'use client';

import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import Image from 'next/image';
import KeyTakeAway from '../KeyTakeAway';
import { BlogBody } from '../DynamicText';
import BookConsultation from '../../app/[slug]/components/BookConsultation';

const components = {
  Image,
  KeyTakeAway,
  BlogBody,
  BookConsultation,
  h1: (props: any) => <h1 className='mb-4 text-4xl font-bold' {...props} />,
  h2: (props: any) => <h2 className='mb-3 text-3xl font-semibold' {...props} />,
  h3: (props: any) => <h3 className='mb-2 text-2xl font-medium' {...props} />,
  p: (props: any) => <p className='mb-4 leading-relaxed' {...props} />,
  ul: (props: any) => <ul className='mb-4 list-disc pl-6' {...props} />,
  ol: (props: any) => <ol className='mb-4 list-decimal pl-6' {...props} />,
  li: (props: any) => <li className='mb-1' {...props} />,
  blockquote: (props: any) => (
    <blockquote
      className='my-4 border-l-4 border-gray-300 pl-4 italic'
      {...props}
    />
  ),
  code: (props: any) => (
    <code className='rounded bg-gray-100 px-1 py-0.5 text-sm' {...props} />
  ),
  pre: (props: any) => (
    <pre
      className='mb-4 overflow-x-auto rounded-lg bg-gray-100 p-4'
      {...props}
    />
  ),
  strong: (props: any) => <strong className='font-semibold' {...props} />,
  em: (props: any) => <em className='italic' {...props} />,
  a: (props: any) => (
    <a className='text-blue-600 underline hover:text-blue-800' {...props} />
  ),
};

export function CustomMDX(props: any) {
  const { source, ...rest } = props;

  // Simple markdown parsing for basic formatting
  const parseMarkdown = (markdown: string) => {
    if (!markdown) return '';

    return (
      markdown
        // Headers
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        // Bold
        .replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>')
        // Italic
        .replace(/\*(.*)\*/gim, '<em>$1</em>')
        // Links
        .replace(/\[([^\]]+)\]\(([^)]+)\)/gim, '<a href="$2">$1</a>')
        // Line breaks
        .replace(/\n/gim, '<br />')
    );
  };

  // Ensure parsedContent is a valid string for dangerouslySetInnerHTML
  const parsedContent = parseMarkdown(String(source || ''));

  return (
    <MDXProvider components={components}>
      <div dangerouslySetInnerHTML={{ __html: parsedContent }} {...rest} />
    </MDXProvider>
  );
}
